// react
import { Link as RouterLink } from 'react-router-dom';


// @mui
import { Box, Card, Container, Link, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
import useLanguage from '../../hooks/useLanguage';
// components
import Image from '../../components/Image';
import Logo from '../../components/Logo';
import Page from '../../components/Page';
// sections
import { LoginForm } from '../../sections/auth/login';
// images
import imageUser from "../../assets/images/index/shield.webp";
import { stringToTitle } from '../../utils/stringToTitle';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  // hooks
  const { method } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const { getLocalizedPath } = useLanguage();

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>
          <Logo icon="icon-title-black" sx={{ height: 43 }} />
          {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 } }}>
              ¿No tienes una cuenta?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to={getLocalizedPath(PATH_AUTH.register)}>
                Regístrate aquí
              </Link>
            </Typography>
          )}
        </HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              ¡Hola! Es un placer darte la bienvenida
            </Typography>
            <Image visibleByDefault disabledEffect src="/assets/illustrations/illustration_login.webp" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Iniciar sesión
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>Introduce tus datos a continuación.</Typography>
              </Box>

              <Tooltip title={stringToTitle(method)} placement="right">
                <>
                  <Image
                    disabledEffect
                    src={imageUser}
                    sx={{ height: 50, width: 50 }}
                  />
                </>
              </Tooltip>
            </Stack>

            <LoginForm />

            {!smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                ¿No tienes una cuenta?&nbsp;
                <Link variant="subtitle2" component={RouterLink} to={getLocalizedPath(PATH_AUTH.register)}>
                  Registrate
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
